import { useContext, useEffect, useState } from "react";
import style from "./contactUs.module.css";
import {
  getContactDetailsApi,
  postContactRequestApi,
} from "../../Api/services";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import notificationObject from "../../components/Widgets/Notification/Notification";
import { IoMdCall } from "react-icons/io";
import { MdOutlineLocationOn } from "react-icons/md";
import { AiTwotoneMail } from "react-icons/ai";
import { GlobalContext } from "../../context/Context";
import NavigationPath from "../../components/NavigationPath/NavigationPath";
import { useLocation } from "react-router-dom";

const ContactUs = () => {
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);
  const [contactDetails, setContactDetails] = useState({});
  const [officeAddress, setOfficeAddress] = useState(""); // New state for office address
  
  const [contactNumber, setContactNumber] = useState(""); // New state for office address
  
  const initialValues = {
    name: "",
    countryCode: "+91",
    contact_number: "",
    email: "",
    query: "",
  };

  const validationSchema = Yup.object({
    contact_number: Yup.number()
      .transform((value, originalValue) =>
        /\s/.test(originalValue) ? NaN : value
      )
      .integer()
      .typeError("Please enter 10 digit mobile number ")
      .required("Please enter mobile number")
      .min(1000000000, "Please enter 10 digit mobile number ")
      .max(9999999999, "Please enter 10 digit mobile number "),

    name: Yup.string()
      .matches(
        /^[a-zA-Z0-9\u0900-\u097F\s]+$/,
        "Please remove special characters"
      )
      .required("Please enter name"),
    email: Yup.string().trim().email("Please enter email in correct format"),
  });
  const renderError = (message) => (
    <span className={`${style.validationMsgContainer}`}>{message}</span>
  );

  async function submitContactRequest(values) {
    const requestData = {
      name: values.name,
      countryCode: values.countryCode,
      contact_number: values.contact_number,
      email: values.email,
      query: values.query,
    };

    const formData = new FormData();
    formData.append("name", values.name);
    formData.append("countryCode", values.countryCode);
    formData.append("contact_number", values.contact_number);
    formData.append("email", values.email);
    formData.append("message", values.query);
    const response = await postContactRequestApi(formData);
    if (response.message) {
      notificationObject.success(response.message);
    } else if (response.error) {
      notificationObject.dismissAll();
      notificationObject.error(response.error);
    }
  }
  const onSubmit = (values) => {
    submitContactRequest(values);
  };

  const contactUsDetails = async () => {
    try {
      const response = await getContactDetailsApi();
      setContactDetails(response?.contact_us_details);
    } catch (error) {
      console.error("Error fetching Contact Us details:", error);
    }
  };

  const path = window.location.pathname;

  const updateOfficeAddress = () => {

    if (path.includes("/contact/newzealand")) {
      setOfficeAddress("");
      setContactNumber(contactDetails?.contact_number_newzealand || "")

    } else if (path.includes("/contact/uk")) {
      setOfficeAddress("");
      setContactNumber(contactDetails?.contact_number_uk || "")

    } else if (path.includes("/contact/us")) {
      setOfficeAddress("");
      setContactNumber(contactDetails?.contact_number_usa || "")

    } else if (path.includes("/contact/india")) {
      setOfficeAddress(contactDetails?.office_address || "");
      setContactNumber(contactDetails?.business_contact_number || "")
    }
  };
  // Code changed by - Ashlekh on 30-01-2025
  // Reason - To display path of all country
  // useEffect(() => {
  //   // Fetch contact details and update office address
  //   contactUsDetails();
  //   setNavigationPath([
  //     { name: "Home", path: "/" },
  //     { name: "Contact Us India", path: "/contact/india" },
  //   ]);
  // }, []); // Run once on mount
  useEffect(() => {
    // Fetch contact details and update office address
    contactUsDetails();
  }, []); 
  const countryMap = {
    india: "India",
    us: "US",
    newzealand: "New Zealand",
    uk: "UK",
  };
  const location = useLocation();
  useEffect(() => {
    const pathParts = location?.pathname?.split("/");
    const countryKey = pathParts[pathParts?.length - 1];
    const countryName = countryMap[countryKey] || "";

    setNavigationPath([
      { name: "Home", path: "/" },
      { name: `Contact Us ${countryName}`, path: location.pathname },
    ]);
  }, [location.pathname]);

  // End of code - Ashlekh on 30-01-2025
  // Reason - To display path of all country

  useEffect(() => {
    // Update the office address when the path or contact details change
    updateOfficeAddress();
  }, [window.location.pathname, contactDetails]);

  return (
    <div className={`${style.mainContainer}`}>
      <NavigationPath navigationPathArray={navigationPath} />
      <div className={style.title}>
                    <span className={style.firstThree}>
                      Con
                    </span>
                    <span className={style.gradientText}>
                      tact Us
                    </span>
                  </div>

      <div className={`${style.subContainer}`}>
        {contactDetails?.business_contact_number ||
        contactDetails?.business_contact_number?.trim()?.length > 0 ||
        contactDetails.email ||
        contactDetails?.email?.trim()?.length > 0 ||
        contactDetails.office_address ||
        contactDetails?.office_address?.trim()?.length > 0 ||
        contactDetails.factory_address ||
        contactDetails?.factory_address?.trim()?.length > 0 ? (
          <div className={`${style.descriptionContent}`}
            style={{ height: officeAddress ? "24vh" : "16vh" }}
          >
            <div className={`${style.descriptionSubContent}`}>
              {/* {contactDetails.office_address &&
              contactDetails?.office_address?.trim()?.length > 0 ? ( */}
              {path.includes("/contact/india") ? (
                <div className={`${style.addressContainer}`}>
                  <div className={`${style.iconField}`}>
                    <MdOutlineLocationOn className={`${style.locationIcon}`} />
                  </div>
                  <div className={`${style.address}`}>
                    <span>Office address: </span>{" "}
                    {/* {contactDetails?.office_address} */}
                    {officeAddress}
                  </div>
                </div>
              ) : null}

              {contactDetails?.business_contact_number &&
              contactDetails?.business_contact_number?.trim()?.length > 0 ? (
                <div className={`${style.mobileContainer}`}>
                  <div className={`${style.iconField}`}>
                    <IoMdCall className={`${style.contactIcon}`} />{" "}
                  </div>
                  <div className={`${style.mobile}`}>
                    <span>Contact Number: </span>{" "}
                    {/* {contactDetails?.business_contact_number} */}
                    {contactNumber}

                  </div>
                </div>
              ) : null}

              {contactDetails.career_contact_number &&
                contactDetails.career_contact_number?.trim()?.length > 0 && (
                  <div className={`${style.mobileContainer}`}>
                    <div className={`${style.iconField}`}>
                      <IoMdCall className={`${style.contactIcon}`} />{" "}
                    </div>

                    <div className={`${style.mobile}`}>
                      <span>For general query: </span>{" "}
                      {contactDetails?.career_contact_number}
                    </div>
                  </div>
                )}

              {contactDetails.email ||
              contactDetails?.email?.trim()?.length > 0 ||
              contactDetails?.second_email ||
              contactDetails?.second_email?.trim()?.length > 0 ? (
                <div className={`${style.emailContainer}`}>
                  <div className={`${style.iconField}`}>
                    <AiTwotoneMail className={`${style.emailIcon}`} />
                  </div>

                  <div className={`${style.email}`}>
                    <span>Email: </span> {contactDetails?.email}
                    {contactDetails?.email && contactDetails?.second_email ? (
                      <> || </>
                    ) : null}
                    {contactDetails?.second_email}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}

        <div className={`${style.contactUsFormContainer}`}>
          <div className={`${style.contactUsTitle}`}>
            Please fill this form to get in touch with us
          </div>
          <div className={`${style.formContainer}`}>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={async (values, { resetForm }) => {
                await onSubmit(values);
                resetForm();
              }}
              enableReinitialize={true}
            >
              <Form noValidate={true}>
                <div className={`${style.inputHolder}`}>
                  <div className={`${style.inputWithError}`}>
                    <Field
                      name="name"
                      type="text"
                      placeholder="Name *"
                      className={`${style.inputBox}`}
                    />
                    <ErrorMessage name="name" render={renderError} />
                  </div>
                </div>

                <div className={`${style.inputHolder}`}>
                  <div className={style.country_code_and_mobile_number}>
                    <Field
                      name="countryCode"
                      type="text"
                      className={`${style.countryInput}`}
                      onInput={(e) => {
                        let value = e.target.value;
                        if (value === "") {
                          return;
                        }
                        if (value.startsWith("+")) {
                          e.target.value =
                            "+" + value.slice(1).replace(/\D/g, "").slice(0, 4);
                        } else {
                          e.target.value = value.replace(/\D/g, "").slice(0, 5);
                        }
                      }}
                    />
                    <div className={`${style.inputWithError}`}>
                      <Field
                        name="contact_number"
                        type="number"
                        placeholder="Mobile Number *"
                        className={`${style.inputBox}`}
                      />
                      <ErrorMessage
                        name="contact_number"
                        render={renderError}
                      />
                    </div>
                  </div>
                </div>

                <div className={`${style.inputHolder}`}>
                  <div className={`${style.inputWithError}`}>
                    <Field
                      name="email"
                      type="text"
                      placeholder="Email"
                      className={`${style.inputBox}`}
                    />
                    <ErrorMessage name="email" render={renderError} />
                  </div>
                </div>

                <div className={`${style.inputHolder}`}>
                  <div className={`${style.inputWithError}`}>
                    <Field
                      component="textarea"
                      id="textareaField"
                      name="query"
                      placeholder="Message"
                      className={`${style.textArea}`}
                      style={{ resize: "none" }}
                    />
                  </div>
                </div>

                <div
                  className={`${style.buttonContainer}`}
                  style={{ paddingTop: "2%" }}
                >
                  <button className={`${style.button}`} type="submit">
                    Submit
                  </button>
                </div>
              </Form>
            </Formik>
          </div>
        </div>
      </div>
      {contactDetails?.map_location_of_office != "" && (
        <iframe
          className={`${style.map}`}
          title="Map"
          src={contactDetails?.map_location_of_office}
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
          style={{ border: "0", outline: "none" }}
        ></iframe>
      )}
    </div>
  );
};
export default ContactUs;
